import "./style.css";
import { useState, useEffect } from "react";
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import { useInView } from "framer-motion";
import { useRef } from "react";
import anime from "animejs";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ScrollToTop from "../../Components/scrollup";
import ScrollPage from "../../Components/scrollpageUp";
import Footer from "../../Components/Footer";
import { Realisation } from "../../Data/cardData";
import useMediaQuery from '@mui/material/useMediaQuery';

const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1080,
      lg: 1280,
    },
  },
  palette: {
    primary: {
      main: "#00897b",
      light: "#80cbc4",
      dark: "#00695c",
      contrastText: "#fff",
    },
  },
});
export default function Realisations() {
  const [isOpen, setIsOpen] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
const isSmallScreen = useMediaQuery('(max-width:750px)');

  
  const ref3 = useRef(null);
  const isInView3 = useInView(ref3, { once: true });
  useEffect(() => {
    anime({
      targets: ".gammeDiv",
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(200, { start: 300 }),
      easing: "easeInOutQuad",
    });
  }, []);
  useEffect(() => {
    const elements = document.querySelectorAll(".gammeDiv:not(.vide)");
    anime({
      targets: elements,
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(300, { start: 400 }),
      easing: "easeInOutQuad",
    });
  }, []);
  useEffect(() => {
    anime({
      targets: ".referenceDiv",
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(200, { start: 300 }),
      easing: "easeInOutQuad",
    });
  }, []);
  useEffect(() => {
    const elements = document.querySelectorAll(".referenceDiv:not(.vide)");
    anime({
      targets: elements,
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(300, { start: 400 }),
      easing: "easeInOutQuad",
    });
  }, []);
   const [categorie, setAlignment] = React.useState('tous');



const selected =
  categorie === "tous"
    ? Realisation
    : Realisation.filter((item) => item.category === categorie);
useEffect(() => {
  const timer = setTimeout(() => {
    const elems = document.querySelectorAll(".realisationDiv");
    elems.forEach(el => el.classList.add("visible"));
  }, 10); // Légère attente pour que le DOM se mette à jour

  return () => {
    clearTimeout(timer);
    const elems = document.querySelectorAll(".realisationDiv");
    elems.forEach(el => el.classList.remove("visible"));
  };
}, [categorie]);
  return (
    <ThemeProvider theme={customTheme}>
      <div className="home">
        <ScrollToTop />
        <ScrollPage />

        <div className="realisationHome"  ref={ref3}
                style={{
                  transform: isInView3 ? "none" : "translateY(-200px)",
                  opacity: isInView3 ? 1 : 0,
                  transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
                }}>
          <h1>Nos Réalisations</h1>
          <div>
            <div className="categorieSelector">
  {["tous", "professionnels","multiresidentiels", "residentiels"].map((cat) => (
    <span
      key={cat}
      className={`categorieBtn ${categorie === cat ? "active" : ""}`}
      onClick={() => setAlignment(cat)}
    >
      {cat}
    </span>
  ))}
</div>

        <ImageList variant="masonry" cols={isSmallScreen ? 2 : 3} gap={isSmallScreen ? 6 : 8}>

       {selected?.map((item, idx) => (
          <ImageListItem key={item.nom} className="realisationDiv">
              <a href={`/${item.nom}`} >
  <div className="imageContainer">
       <img
              srcSet={`${`https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2Frealisations%2Ftous%2F${encodeURIComponent(item.category)}%20${encodeURIComponent(item.nom)}.jpg?alt=media`}`}
              src={`${`https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2Frealisations%2Ftous%2F${encodeURIComponent(item.category)}%20${encodeURIComponent(item.nom)}.jpg?alt=media`}`}
              alt={item.title}
              loading="lazy"
               className="realisationImg"
            />
    <div className="overlay">
      <span className="projectName">{item.title}</span>
    </div>
  </div>
  </a>
</ImageListItem>

        ))}
      </ImageList>
          </div>
        </div>
      
        <Footer />
      </div>
    </ThemeProvider>
  );
}


